import { render } from "./PhotoForm.vue?vue&type=template&id=524e7e48&scoped=true"
import script from "./PhotoForm.vue?vue&type=script&lang=js"
export * from "./PhotoForm.vue?vue&type=script&lang=js"

import "./PhotoForm.vue?vue&type=style&index=0&id=524e7e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524e7e48"]])

export default __exports__